import type { ISerializationPort } from "@/core/ports";

export class JsonSerializer implements ISerializationPort {
  serialize<T>(data: T): string {
    return JSON.stringify(data);
  }

  deserialize<T>(data: string): T {
    return JSON.parse(data) as T;
  }
}
